import React, { } from "react";
import logo from "./../assets/img/BAbianco.png"
import { Layout } from "antd";
const { Content, Header } = Layout;

const TopBarHomeOperatore = ({ children }) => {

  return (
    <Layout style={{
      height: '100vh',
      backgroundColor: 'white',
      overflow: 'hidden',
      paddingTop: localStorage.getItem('nomeOperatore') ? 64 : ''
    }}>
      {/* <Header style={{ backgroundColor: '#003897' }}>
        
        <img src={logo} alt="Banco Azzoaglio" width={160}  style={{ padding: 5, marginBottom: 5 }}/>
      </Header> */}
      {
        localStorage.getItem('nomeOperatore') &&
        <Header style={{
          backgroundColor: "#003897",
          display: "flex",
          justifyContent: "center",
          // marginRight:,
          position: 'fixed',
          width: '100%',
          zIndex: 100,
          left: 0,
          top: 0,
          height: 64
        }}>
          <div style={{ position: "absolute", left: 20, top: 0 }}>
            <img src={logo} alt="Banco Azzoaglio" width={160} style={{ padding: 5, marginBottom: 5/* , marginLeft: "-47px" */ }} />
          </div>
          <div style={{ color: "white", fontFamily: "Poppins-Regular", fontSize: 18, }}>
            Matricola: {localStorage.getItem('matricolaOperatore')} - {localStorage.getItem('nomeOperatore')} - {localStorage.getItem('nomeFiliale')}
          </div>

        </Header>
      }

      <Content style={{ overflowY: 'scroll' }}>
        {children}
      </Content>
    </Layout >


  );
};

export default TopBarHomeOperatore;
